import _ from 'lodash'
import { useCallback } from 'react'
import { FormGroup, FormFeedback } from 'reactstrap'
import { Dropdown } from 'common-components'

const Title = (props) => {
  const className = _.isEmpty(props.errors) ? '' : 'has-danger'
  const isOther = props.value.value === 'other'

  const onDropdownChange = useCallback(
    (selectedValue) => {
      const opt = _.find(props.options, { value: selectedValue })
      const text = opt && opt.value !== 'other' ? opt.text : ''
      props.onChange({ value: selectedValue, text })
    },
    [props.options, props.onChange]
  )

  const onOtherChange = useCallback(
    (e) => {
      props.onChange({ value: props.value.value, text: e })
    },
    [props.value.value, props.onChange]
  )

  return (
    <div className="title-selection">
      <FormGroup className={className}>
        {props.label && <label>{props.label}</label>}
        <Dropdown
          testId={props.testId}
          options={props.options}
          onChange={onDropdownChange}
          value={props.value.value}
          placeHolder="กรุณาเลือก"
        />
      </FormGroup>
      {isOther && (
        <FormGroup className={className}>
          <label>ระบุคำนำหน้า</label>
          <input
            data-testid={props.testId}
            className="form-control"
            type="text"
            placeholder={props.placeholder}
            value={props.value.text}
            onChange={(e) => onOtherChange(e.target.value)}
            onBlur={(e) => {
              if (e.target.value === '') {
                onOtherChange(props.defaultValue.value)
              }
            }}
          />
          <FormFeedback className="validation-message mb">{props.errors}</FormFeedback>
        </FormGroup>
      )}
    </div>
  )
}

Title.displayName = 'Title'

export default Title
